import { ReactNode } from "react";


type TableBodyCellProps = {
    children: ReactNode;
    style?: React.CSSProperties
}

export const TableBodyCell = ({ children, style }: TableBodyCellProps) => {
    return (
        <td style={style}>
            <div>
                {children}
            </div>
        </td>
    )
}